import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import _ from "lodash";

export default class SolicitacaoDentroForaPrazoStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.indicadorService = new IndicadorService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findSolicitacaoDentroForaPrazo(filtro).then(response => {
            if(response.data && response.data.length > 0) {
                this.dados = [{
                    nome: "Novas",
                    "Prazo ideal": this.getQuantidade(response.data, "NOVA_SOLICITACAO", 0),
                    "Prazo curto": this.getQuantidade(response.data, "NOVA_SOLICITACAO", 1)
                }, {
                    nome: "Não MTE",
                    "Prazo ideal": this.getQuantidade(response.data, "PRORROGACAO_NAO_MTE", 0),
                    "Prazo curto": this.getQuantidade(response.data, "PRORROGACAO_NAO_MTE", 1)
                }, {
                    nome: "MTE",
                    "Prazo ideal": this.getQuantidade(response.data, "PRORROGACAO_MTE", 0),
                    "Prazo curto": this.getQuantidade(response.data, "PRORROGACAO_MTE", 1)
                }];
            } else {
                this.dados = [];
            }

            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    getQuantidade = (solicitacoes, tipo, prazo) => {
        const solicitacao = _.find(solicitacoes, {
            "tipo": tipo,
            "prazo": prazo
        });

        return solicitacao ? solicitacao.quantidade : 0;
    }
}
